// extracted by mini-css-extract-plugin
module.exports = {"button":"solid-button_button__2X5a2","smallButton":"solid-button_smallButton__2sGNv"};